export default {
  acceptTermsRequired: 'অনুগ্রহ করে terms and conditions গ্রহণ করুন',
  accountNumber: 'A/C Number',
  acknowledgeText: 'স্বীকার করুন',
  acknowledgedText: 'স্বীকৃত',
  active: 'সক্রিয়',
  activeBookings: 'সক্রিয় বুকিং',
  activeBucketsText: 'সক্রিয় বাকেট',
  activeToday: 'আজ সক্রিয়',
  adminRole: 'অ্যাডমিন — ব্যবস্থাপনা পরিচালক',
  advance: 'অগ্রিম',
  advancePaid: 'অগ্রিম প্রদত্ত',
  advancePaidLabel: 'অগ্রিম',
  agreeTermsCheckbox: 'আমি সমস্ত শর্তাবলী ও শর্ত পড়েছি এবং সম্মত',
  agreement: 'শর্তাবলী ও চুক্তি',
  alertLog: 'সতর্কতা লগ',
  alertText: 'সতর্কতা',
  alerts: 'সতৰ্কতা',
  allAlerts: 'সমস্ত সতর্কতা',
  allLoaded: 'সব লোড',
  allMachinesOk: 'সমস্ত মেশিন ঠিকমতো চলছে।',
  allStats: 'সম্পূর্ণ পরিসংখ্যান',
  allowedText: 'অনুমোদিত',
  amount: 'পরিমাণ',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'ডেভেলপমেণ্ট এক্সপ্ৰেছ',
  approvals: 'অনুমোদন',
  approveAndDispatch: 'অনুমোদন করে মেশিন পাঠান',
  approved: 'অনুমোদিত',
  assignedOperator: 'নিয়োজিত অপারেটর',
  attemptsLabel: 'চেষ্টা',
  attendance: 'উপস্থিতি',
  auditLogs: 'অডিট লগ',
  available: 'উপলব্ধ',
  availableMachinery: 'উপলব্ধ মেশিনারি',
  availableNow: 'এখন উপলব্ধ',
  avgRating: 'গড় রেটিং',
  awaitingClientFeedback: 'গ্রাহক প্রতিক্রিয়ার জন্য অপেক্ষা',
  awaitingDispatch: 'ডিসপ্যাচের জন্য অপেক্ষা',
  back: 'পিছনে',
  backToLogin: 'লগইনে ফিরে যান',
  bank: 'ব্যাংক',
  bankDetailsTitle: 'ব্যাংক বিবরণ',
  baseAmount: 'মূল পরিমাণ',
  billingWallet: 'ওয়ালেট ও বিলিং',
  blacklistWarning: '⛔ ব্লেকলিষ্ট সতৰ্কতা',
  blockedRateText: 'ব্লক রেট',
  blockedText: 'ব্লক করা',
  bookMachine: 'মেচিন বুক কৰক',
  bookMachineAction: 'মেশিন বুক করুন',
  bookNow: 'এখনই বুক করুন',
  bookingConfirm: 'বুকিং নিশ্চিত করুন',
  bookingCostCalculator: 'বুকিং ও খরচ ক্যালকুলেটর',
  bookingFailedGeneric: 'বুকিং ব্যর্থ। আবার চেষ্টা করুন।',
  bookingHistory: 'বুকিং ইতিহাস',
  bookingReportTitle: 'বুকিং রিপোর্ট',
  bookingScheduleSummary: 'দৈনিক ও মাসিক বুকিং সময়সূচি',
  bookingSelectMachineFirst: 'চালিয়ে যেতে ফ্লিট থেকে মেশিন নির্বাচন করুন।',
  bookingStepChoose: 'মেশিন নির্বাচন',
  bookingStepConfirm: 'নিশ্চিত করে পেমেন্ট',
  bookingStepCost: 'খরচ ও তারিখ',
  bookingType: 'বুকিং ধরন নির্বাচন',
  bookingTypeLabel: 'বুকিং ধরন',
  bookingTypeText: 'বুকিং ধরন',
  bookingsCount: '{count} বুকিং',
  bookingsScheduleHint: 'গ্রাহকরা বুক করলে দৈনিক সময়সূচি এখানে দেখা যাবে।',
  burstText: 'BURST',
  busy: 'ব্যস্ত',
  callNow: 'এখনই কল করুন',
  cancel: 'বাতিল',
  cancelAction: 'বাতিল করুন',
  cancelBooking: 'বুকিং বাতিল',
  cancelBookingPrompt: 'বুকিং বাতিল করবেন?',
  cancelPolicy: 'বাতিল নীতি',
  cancelText: 'বাতিল',
  cancelWarning: 'আপনি কি বাতিল করতে চান?',
  changeLanguage: 'ভাষা সলনি কৰক',
  changeMachine: 'মেশিন পরিবর্তন',
  changeMobileNumber: 'মোবাইল নম্বর পরিবর্তন',
  chipAction: 'কর্ম',
  chipActor: 'অভিনেতা',
  chipEntity: 'entity',
  chipFrom: 'থেকে',
  chipMeta: 'meta',
  chipRole: 'ভূমিকা',
  chipTo: 'পর্যন্ত',
  clearAll: 'সব মুছুন',
  client: 'গ্রাহক',
  clientFeedbackLabel: 'গ্রাহক প্রতিক্রিয়া',
  clientPortal: 'ক্লাইণ্ট পৰ্টেল',
  clientRatingsTitle: 'গ্রাহক রেটিং ও পরামর্শ',
  clientRole: 'গ্রাহক (ঠিকাদার)',
  clients: 'গ্রাহক',
  commission: 'কমিশন',
  commission15: 'কমিশন ১৫%',
  commissionPaid: 'কমিশন প্রদত্ত',
  commissionRate: 'মোট বিলিংয়ের ১৫%',
  company: 'কোম্পানি',
  companyDetailsTitle: 'কোম্পানির বিবরণ',
  completeBookings: 'সম্পন্ন বুকিং',
  completedBookings: 'সম্পন্ন বুকিং',
  condition: 'অবস্থা',
  confirm: 'নিশ্চিত কৰক',
  confirmBooking: 'বুকিং নিশ্চিত করুন',
  confirmBookingAction: 'বুকিং নিশ্চিত করুন',
  confirmCancel: 'বাতিল নিশ্চিত করুন',
  confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
  confirmRetry: 'পুনরায় চেষ্টা নিশ্চিত করুন',
  contactCompany: 'Development Express-এ যোগাযোগ করুন',
  costCalculator: 'খরচ ক্যালকুলেটর',
  crawlerNoRto: 'Crawler (RTO নেই)',
  currentlyDeployed: 'বর্তমানে মোতায়েন',
  customAmount: 'কাস্টম পরিমাণ (ন্যূনতম ₹৫,০০০)',
  cycles: "চক্ৰ",
  dailyWorkReport: 'দৈনিক কাজের রিপোর্ট',
  dashboard: 'ড্যাশবোৰ্ড',
  date: 'তারিখ',
  dayMachinesLabel: 'মেশিন',
  days: 'দিন',
  daysUnit: 'দিন',
  directContactBlacklist: 'সরাসরি যোগাযোগ = ব্ল্যাকলিস্ট',
  directContactProhibited: 'সরাসরি যোগাযোগ কঠোরভাবে নিষিদ্ধ',
  directContactProhibitedText: 'সরাসরি যোগাযোগ কঠোরভাবে নিষিদ্ধ',
  dispatched: 'প্রেরিত',
  dlqMonitor: 'DLQ মনিটর',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC নেই)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documentUploadTitle: 'নথি আপলোড',
  documents: 'নথি আপলোড',
  download: 'ডাউনলোড',
  drawerMenu: 'মেনু',
  earnings: 'আয়',
  email: 'ইমেইল সহায়তা',
  emailAddress: 'ইমেইল ঠিকনা',
  emailAddressLabel: 'ইমেইল ঠিকানা',
  expandBookingHint: 'সম্পূর্ণ বুকিং, বাতিল ও অপারেটর রেটিংয়ের জন্য নিচে মাস/দিন বিভাগ প্রসারিত করুন।',
  experience: 'অভিজ্ঞতা',
  exportCsv: 'CSV এক্সপোর্ট',
  failedText: 'ব্যর্থ',
  feedbackAfterDispatch: 'মেশিন ডিসপ্যাচের পর অপারেটর রেটিং উপলব্ধ হবে।',
  feedbackStatusAfterDispatch: 'ডিসপ্যাচের পর',
  feedbackStatusRateNow: 'অপারেটর রেট করুন ↓',
  filterAll: 'সব',
  filterCredit: 'ক্রেডিট',
  filterDebit: 'ডেবিট',
  filterCompleted: 'সম্পূৰ্ণ',
  filterCancelled: 'বন্ধ',
  filterPending: 'অপেক্ষমাণ',
  filterDisputed: 'বিবাদ',
  forgotPasswordChooseMethod: 'পাসওয়ার্ড রিসেটের জন্য ইমেইল লিংক বা SMS OTP বেছে নিন।',
  forgotPasswordEmailDevHint: 'Local dev: API server টার্মিনাল খুলে “Password reset link (development)” URL কপি করুন।',
  forgotPasswordEmailHint: 'নিবন্ধিত অ্যাডমিন ইমেইল ঠিকানা লিখুন।',
  forgotPasswordFailed: 'রিসেট লিংক পাঠাতে ব্যর্থ। আবার চেষ্টা করুন।',
  forgotPasswordIntro: 'নিবন্ধিত ইমেইল ঠিকানায় নিরাপদ রিসেট লিংক পাঠাব।',
  forgotPasswordInvalidEmail: 'বৈধ ইমেইল ঠিকানা লিখুন।',
  forgotPasswordInvalidOtp: 'SMS থেকে ৬ সংখ্যার OTP লিখুন।',
  forgotPasswordInvalidPhone: 'বৈধ ১০ সংখ্যার মোবাইল নম্বর লিখুন।',
  forgotPasswordLink: 'পাসওয়ার্ড ভুলে গেছেন?',
  forgotPasswordOtpSentTo: 'OTP পাঠানো হয়েছে:',
  forgotPasswordPhoneHint: 'নিবন্ধিত মোবাইল নম্বর লিখুন। রিসেট লিংক আপনার অ্যাকাউন্টের ইমেইলে যাবে।',
  forgotPasswordSendOtp: 'OTP পাঠান',
  forgotPasswordSending: 'পাঠানো হচ্ছে...',
  forgotPasswordSendingOtp: 'OTP পাঠানো হচ্ছে...',
  forgotPasswordSmsDevHint: 'Production-এ SMS এখনো সেট নয় — development-এ OTP কোডের জন্য server logs দেখুন।',
  forgotPasswordSmsFailed: 'OTP পাঠাতে ব্যর্থ। আবার চেষ্টা করুন।',
  forgotPasswordSmsHint: 'নিবন্ধিত মোবাইল নম্বর লিখুন। ৬ সংখ্যার OTP SMS-এ পাঠানো হবে।',
  forgotPasswordSmsSuccess: 'অ্যাকাউন্ট থাকলে, নিবন্ধিত মোবাইলে OTP পাঠানো হয়েছে।',
  forgotPasswordSubmit: 'রিসেট লিংক পাঠান',
  forgotPasswordSuccess: 'অ্যাকাউন্ট থাকলে, নিবন্ধিত ইমেইলে রিসেট নির্দেশনা পাঠানো হয়েছে।',
  forgotPasswordTitle: 'আপনার পাসওয়ার্ড রিসেট করুন',
  formLabel: 'ফর্ম',
  fuel: 'জ্বালানি',
  fuelColon: 'জ্বালানি:',
  fuelHistoryTitle: 'জ্বালানি ইতিহাস',
  fuelLevel: 'জ্বালানি স্তর',
  fuelLevelUpdate: 'জ্বালানি স্তর আপডেট',
  fuelNotePlaceholder: 'নোট: ভরাট / ব্যবহৃত জ্বালানি...',
  fullName: 'পূর্ণ নাম',
  goBook: '→ মেশিন বুক করুন',
  gpsLiveLabel: '🟢 GPS লাইভ',
  grandTotal: 'সর্বমোট',
  grandTotalText: 'সর্বমোট',
  gross: 'মোট',
  grossBilling: 'মোট বিলিং',
  gst18: 'GST (18%)',
  gstInvoice: 'GST ইনভয়েস',
  gstInvoices: 'GST ইনভয়েস',
  gstin: 'GSTIN',
  hide: 'লুকান',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'ঘণ্টা',
  hmrToday: 'আজকের HMR',
  hmrTotal: 'মোট HMR',
  home: 'হোম',
  hours: 'ঘণ্টা',
  hrsUnit: 'ঘণ্টা',
  idle: 'নিষ্ক্রিয়',
  ifsc: 'IFSC',
  ignition: 'ইগনিশন',
  importantInfo: 'মেশিন মালিকদের জন্য গুরুত্বপূর্ণ তথ্য',
  instantCost: 'তাৎক্ষণিক খরচ ক্যালকুলেটর',
  invoiceNotAvailableCancelled: 'ইনভয়েস উপলব্ধ নয় (বাতিল)',
  iot: 'IoT & GPS',
  issueReportTitle: 'সমস্যা রিপোর্ট',
  issueReportedSuccess: 'সমস্যা সফলভাবে রিপোর্ট হয়েছে!',
  issues: 'সমস্যা',
  joinUsAction: 'Join Us — বিনামূল্যে নিবন্ধন',
  joinUsBanner: 'মেশিনারি ভাড়া চান?',
  joinUsHint: 'নতুন গ্রাহক? JCB, excavator, crane বুক করতে বিনামূল্যে নিবন্ধন করুন।',
  landingCtaApp: 'Development Express অন্বেষণ করুন',
  landingFeatBook: 'মিনিটে বুকিং',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'স্বচ্ছ বিলিং, GST invoices, নগদ ঝামেলা নেই।',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'ভাড়ার প্রতিটি ঘণ্টায় আপনার মেশিন কোথায় জানুন।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'মহারাষ্ট্র মেশিনারি ভাড়া — নতুন রীতি।',
  landingSocialProof: 'মহারাষ্ট্র জুড়ে নির্মাতা, ঠিকাদার ও ফ্লিট মালিক।',
  landingStatMachines: 'মেশিন',
  landingStatRating: 'রেটিং',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'শেষ রিফ্রেশ',
  live: 'লাইভ',
  liveBookAvail: 'বুকিংয়ের পর লাইভ ফিড উপলব্ধ',
  liveCamera: '৩৬০° লাইভ ক্যামেরা — বুকিংয়ের পর',
  liveMachineLocation: 'লাইভ মেশিন অবস্থান',
  liveText: 'লাইভ',
  liveTracking: 'লাইভ ট্র্যাকিং',
  loadMoreAlerts: 'আরও সতর্কতা লোড করুন',
  loadMoreAttendance: 'আরও উপস্থিতি লোড করুন',
  loadMoreBookings: 'আরও বুকিং লোড করুন',
  loadMoreDlq: 'আরও DLQ লোড করুন',
  loadMoreFuelLogs: 'আরও জ্বালানি লগ লোড করুন',
  loadMoreLogs: 'আরও লগ লোড করুন',
  loadMoreMachines: 'আরও মেশিন লোড করুন',
  loadMoreTransactions: 'আরও লেনদেন লোড করুন',
  loadMoreUsers: 'আরও ব্যবহারকারী লোড করুন',
  loadedBookings: 'লোড করা বুকিং',
  loadedDlqItems: 'লোড করা DLQ আইটেম',
  loadedFuelLogs: 'লোড করা জ্বালানি লগ',
  loadedOwnerBookings: '{count} মালিক বুকিং লোড{suffix}',
  loading: 'লোড হচ্ছে...',
  loadingDashboard: 'ড্যাশবোর্ড লোড হচ্ছে...',
  location: 'অবস্থান',
  lockConfirm: '🔒 লক নিশ্চিত করুন',
  lockMachine: 'মেশিন লক করুন',
  lockWarning: 'Teltonika GPS-এর মাধ্যমে মেশিন ইগনিশন দূর থেকে বন্ধ হবে।',
  locked: 'লক করা',
  loginAs: 'লগইন করছেন',
  loginChangeRole: 'ভূমিকা পরিবর্তন',
  loginClientPortalSubtitle: 'নির্মাণ মেশিনারি বুক করতে সাইন ইন করুন',
  loginEmailHint: 'অ্যাডমিন লগইনের জন্য নিবন্ধিত ইমেইল ব্যবহার করুন।',
  loginFailedGeneric: 'লগইন ব্যর্থ — অনুগ্রহ করে আবার চেষ্টা করুন',
  loginIAmQuestion: 'আমি কে…?',
  loginModeOtp: 'OTP লগইন',
  loginModePassword: 'পাসওয়ার্ড',
  loginNewHereRegister: 'নতুন? নিবন্ধন',
  loginOtpDevHint: 'Development: SMS না এলে API server log-এ OTP দেখুন।',
  loginOtpHint: 'আপনার নিবন্ধিত মোবাইল নম্বরে ৬ সংখ্যার OTP পাঠানো হবে।',
  loginOtpSentTo: 'OTP পাঠানো হয়েছে:',
  loginOwnerPortalSubtitle: 'ফ্লিট ও নিবন্ধন পরিচালনার জন্য সাইন ইন করুন',
  loginPhoneHint: 'গ্রাহক, মালিক ও অপারেটর লগইনের জন্য নিবন্ধিত মোবাইল নম্বর ব্যবহার করুন।',
  loginPickRoleHint: 'নিবন্ধিত? ভূমিকা বেছে নিন। নতুন? নিচে Join Us।',
  loginPortalAdminSubtitle: 'প্ল্যাটফর্ম নিয়ন্ত্রণ ও অনুমোদন',
  loginPortalAdminTitle: 'অ্যাডমিন পোর্টাল',
  loginPortalClientSubtitle: 'নির্মাণ মেশিনারি বুক করতে সাইন ইন',
  loginPortalClientTitle: 'গ্রাহক পোর্টাল',
  loginPortalOperatorSubtitle: 'নিয়োজিত মেশিন ও লগের জন্য সাইন ইন',
  loginPortalOperatorTitle: 'অপারেটর পোর্টাল',
  loginPortalOwnerSubtitle: 'ফ্লিট ও নিবন্ধন পরিচালনায় সাইন ইন',
  loginPortalOwnerTitle: 'মালিক পোর্টাল',
  loginRoleAdminDesc: 'প্ল্যাটফর্ম নিয়ন্ত্রণ, অনুমোদন ও অপারেশন',
  loginRoleClientDesc: 'নির্মাণ প্রকল্পের জন্য মেশিনারি বুক করুন',
  loginRoleClientShort: 'গ্রাহক',
  loginRoleOperatorDesc: 'নিয়োজিত মেশিন ও দৈনিক লগ',
  loginRoleOwnerDesc: 'ফ্লিট, আয় ও উপলব্ধতা পরিচালনা',
  loginRoleOwnerShort: 'মালিক',
  loginSendOtp: 'OTP পাঠান',
  loginSendingOtp: 'OTP পাঠানো হচ্ছে...',
  loginSignInShort: 'সাইন ইন',
  loginTabOtp: 'OTP',
  loginTabPassword: 'পাসওয়ার্ড',
  loginVerifyOtp: 'Verify & Sign In',
  loginVerifyingOtp: 'Verify হচ্ছে...',
  logout: 'লগআউট',
  sessionRevokedAlert: 'আপুনি আন এটা ডিভাইছত লগ ইন আছে। অনুগ্ৰহ কৰি পুনৰ লগইন কৰক।',
  machine: 'মেশিন',
  machineDefaultLabel: 'মেশিন',
  machineDetails: 'মেশিন ও অপারেটর বিবরণ',
  machineDetailsTitle: 'মেশিন বিবরণ',
  machineDispatchedAt: 'মেশিন পাঠানো হয়েছে — {when}',
  machineHours: 'মেশিন ঘণ্টা',
  machineIdLabel: 'মেশিন ID',
  machineInfo: 'মেশিন তথ্য',
  machineLabel: 'মেশিন',
  machineLog: 'মেশিন লগ',
  machineReg: 'মেশিন নিবন্ধন ফর্ম',
  machineRegistrationSubmitted: 'মেশিন নিবন্ধন জমা হয়েছে! DE দল ২৪ ঘণ্টার মধ্যে যাচাই করবে।',
  machineRegistrationTitle: 'মেশিন নিবন্ধন',
  machineStatus: 'মেশিন অবস্থা',
  machineStatusTitle: 'মেশিন অবস্থা',
  machines: 'মেশিন',
  marketingBackHome: 'ওয়েবসাইটে ফিরে যান',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'নির্ভুলতা, সম্মতি ও গতি চাই এমন ভারতীয় নির্মাণ দলের জন্য।',
  marketingCtaBook: 'মেশিন বুক করুন',
  marketingCtaLogin: 'Development Express খুলুন — Login',
  marketingCtaWhatsApp: 'WhatsApp করুন',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'মহারাষ্ট্রের leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'যোগাযোগ',
  marketingNavLogin: 'প্ল্যাটফর্ম লগইন →',
  marketingNavServices: 'সেবা',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'আমরা কী সরবরাহ করি',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'বছরের অভিজ্ঞতা',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'ন্যূনতম অগ্রিম প্রয়োজন',
  minimumAdvance: 'ন্যূনতম অগ্রিম প্রয়োজন',
  minimumRecharge: 'UPI/কার্ডের জন্য ন্যূনতম ₹1',
  moUnit: 'মাস',
  mobileNumber: 'মোবাইল নম্বর',
  monthMachineSummary: 'এই মাসের মেশিন',
  monthTotalLabel: 'মাসের মোট',
  months: 'মাস',
  moreAvailable: 'আরও উপলব্ধ',
  myBookings: 'মোৰ বুকিং',
  myClientRating: 'আমার গ্রাহক রেটিং',
  myMachines: 'আমার মেশিন',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'নেট আয় (মাস)',
  netPaid: 'নেট প্রদত্ত',
  netPayable: 'নেট প্রদেয়',
  netReceived: 'নেট প্রাপ্ত',
  netReceivedCaps: 'নেট প্রাপ্ত',
  neverText: 'কখনো নয়',
  newBooking: 'নতুন বুকিং',
  newClientRegister: 'নতুন গ্রাহক? এখানে নিবন্ধন করুন',
  newClientRegistration: 'নতুন গ্রাহক নিবন্ধন',
  newPassword: 'নতুন পাসওয়ার্ড',
  nextText: 'পরবর্তী',
  noAlerts: 'কোনো সতর্কতা নেই!',
  noAlertsNow: 'এখন কোনো সতর্কতা নেই।',
  noBankRefund: '❌ ব্যাংক রিফান্ড নেই — শুধু ওয়ালেট ক্রেডিট',
  noBookings: 'কোনো সক্রিয় বুকিং নেই',
  noBookingsAccount: 'এই অ্যাকাউন্টে এখনও বুকিং নেই।',
  noBookingsYet: 'এখনো কোনো বুকিং নেই',
  noClientFeedbackYet: 'এখনো গ্রাহক রেটিং নেই। ডিসপ্যাচের পর গ্রাহক প্রতিক্রিয়া এখানে দেখা যাবে।',
  noDlqItems: 'কোনো DLQ আইটেম নেই',
  noFileSelected: 'কোনো ফাইল নির্বাচিত নয়',
  noMachinesDashboard: 'এখনো কোনো মেশিন নেই। ফ্লিট যোগ করতে মেশিন নিবন্ধন ব্যবহার করুন।',
  noMachinesTrack: 'ট্র্যাক করার মেশিন নেই',
  noMachinesTrackHint: 'GPS ট্র্যাকিংয়ের জন্য মেশিন নিবন্ধন করুন।',
  noMachinesYet: 'এখনো কোনো মেশিন নিবন্ধিত নয়',
  noMoreAuditLogs: 'বর্তমান ফিল্টারের জন্য আর কোনো অডিট লগ নেই।',
  noRecentApiSloBreach: 'সাম্প্রতিক API SLO breach সংকেত নেই।',
  noRecentFailedLogins: 'সাম্প্রতিক ব্যর্থ লগইন চেষ্টা নেই।',
  noRefund: 'রিফান্ড নীতি নেই',
  noSecuritySignalsFound: 'কোনো নিরাপত্তা সংকেত পাওয়া যায়নি।',
  noTransactionsFilter: 'নির্বাচিত ফিল্টারের জন্য লেনদেন নেই।',
  normalText: 'সাধারণ',
  off: 'OFF',
  officeLabel: 'অফিস',
  on: 'ON',
  operator: 'অপারেটর',
  operatorFeedbackColumn: 'অপারেটর প্রতিক্রিয়া',
  operatorFeedbackSaved: 'ধন্যবাদ! আপনার প্রতিক্রিয়া সংরক্ষিত হয়েছে।',
  operatorFeedbackSubmitted: 'আপনার প্রতিক্রিয়া',
  operatorFeedbackTitle: 'অপারেটর প্রতিক্রিয়া',
  operatorPortal: 'অপাৰেটৰ পৰ্টেল',
  operatorRole: 'অপারেটর',
  operatorSatisfactionQuestion: 'আপনি কি অপারেটরে সন্তুষ্ট?',
  operatorSuggestionPlaceholder: 'পরামর্শ বা প্রতিক্রিয়া (ঐচ্ছিক)',
  operators: 'অপারেটর',
  optionalLabel: '(ঐচ্ছিক)',
  otpCode: 'OTP কোড',
  overview: 'সংক্ষিপ্ত বিবরণ',
  ownerBookingsAllLoaded: ' (সব লোড)',
  ownerBookingsMoreAvailable: ' (আরও উপলব্ধ)',
  ownerInfo: 'মালিকের তথ্য',
  ownerPortal: 'মালিক পৰ্টেল',
  ownerRole: 'মেশিন মালিক',
  owners: 'মালিক',
  password: 'পাছৱৰ্ড',
  passwordsMustMatch: 'পাসওয়ার্ড ও নিশ্চিতকরণ একই হতে হবে।',
  pastIssuesTitle: 'পূর্বের সমস্যা',
  payNow: 'এখনই পেমেন্ট',
  payNowText: 'এখনই পেমেন্ট করুন',
  paymentBreakdownTitle: 'পেমেন্ট বিবরণ — April 2026',
  paymentCycle: 'পেমেন্ট চক্র',
  paymentFailed: 'পেমেন্ট ব্যর্থ! অনুগ্রহ করে আবার চেষ্টা করুন।',
  paymentHistory: 'পেমেন্ট ইতিহাস',
  paymentHistoryTitle: 'পেমেন্ট ইতিহাস',
  paymentMethods: 'পেমেন্ট পদ্ধতি',
  paymentMode: 'পেমেন্ট পদ্ধতি',
  paymentSuccess: 'পেমেন্ট সফল!',
  pdfInvoiceFailed: 'ইনভয়েস PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  pdfReportFailed: 'রিপোর্ট PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  pdiCompleted: '✅ PDI / Safety inspection সম্পন্ন',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) প্রয়োজন নেই — মেশিন RTO রোড-registered নয়।',
  pdiInfo: 'PDI পরীক্ষা',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'বাতিল জরিমানা (১ ঘণ্টা)',
  pending: 'মুলতুবি',
  pendingApproval: 'অনুমোদন মুলতুবি',
  pendingCount: '{count} মুলতুবি',
  pendingDispatch: 'ডিসপ্যাচ মুলতুবি',
  perDay: 'প্রতি দিন',
  perHour: 'প্রতি ঘণ্টা',
  perMonth: 'প্রতি মাস',
  perWeek: 'প্রতি সপ্তাহ',
  phone: 'ফোন',
  platform: 'নিৰ্মাণ ব্যৱস্থাপনা প্লেটফৰ্ম',
  platformAgreement: 'প্ল্যাটফর্ম চুক্তি',
  policyLabel: 'নীতি',
  policyTopicBooking: 'বুকিং',
  policyTopicCancellation: 'বাতিল',
  policyTopicContact: 'যোগাযোগ',
  policyTopicGst: 'GST',
  policyTopicHours: 'সাপোর্ট সময়',
  portalBackLink: 'পোর্টাল',
  portalClient: 'গ্রাহক',
  portalClientSub: 'মেশিনারি বুক করুন',
  portalNewClientRegister: 'নতুন গ্রাহক? নিবন্ধন',
  portalNewOwnerRegister: 'নতুন মালিক? নিবন্ধন',
  portalOwner: 'মালিক',
  portalOwnerSub: 'ফ্লিট ব্যবস্থাপনা',
  portalStaffAdmin: 'অ্যাডমিন',
  portalStaffOperator: 'অপারেটর',
  portalWelcome: 'স্বাগতম',
  portalWelcomeHint: 'চালিয়ে যেতে আপনার পোর্টাল নির্বাচন করুন',
  quantityLabel: 'পরিমাণ',
  quickIssueReport: 'দ্রুত সমস্যা রিপোর্ট',
  quickRechargeUpi: 'UPI দিয়ে দ্রুত রিচার্জ',
  quickSelect: 'দ্রুত নির্বাচন:',
  rateCard: 'রেট কার্ড (অপারেটর সহ)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'অপারেটরের কাজ রেট করুন (১–৫ stars)',
  rating: 'রেটিং',
  receiptId: 'রসিদ ID',
  recentAlerts: 'সাম্প্রতিক সতর্কতা',
  recentFailedLoginsTitle: 'সাম্প্রতিক ব্যর্থ লগইন',
  recentLabel: 'সাম্প্রতিক',
  recharge: 'ৰিচাৰ্জ',
  rechargeFirst: '⚡ প্রথমে ওয়ালেট রিচার্জ করুন',
  rechargeWallet: '+ ৱালেট ৰিচাৰ্জ',
  ref: 'রেফারেন্স নম্বর',
  refreshText: 'রিফ্রেশ',
  refreshingText: 'রিফ্রেশ হচ্ছে...',
  regCapacitySpecs: 'ক্ষমতা / বিবরণ',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo ও ID প্রয়োজন। Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC ও ID প্রয়োজন (প্রতি 5MB)।',
  regEquipmentCategory: 'সরঞ্জাম বিভাগ *',
  regFailed: 'নিবন্ধন ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।',
  regFileSizeError: 'প্রতিটি document 5MB বা কম হতে হবে',
  regFileTypeError: 'শুধু PDF, JPG, PNG বা WEBP ফাইল অনুমোদিত',
  regFleetIdOptional: 'ফ্লিট / chassis ID (ঐচ্ছিক)',
  regMachineCategory: 'মেশিন বিভাগ *',
  regMachineInfoTitle: 'মেশিন তথ্য',
  regMachineIntro: 'শুধুমাত্র নির্মাণ heavy equipment — ট্রাক/পরিবহন নয়। Wheeled plant (যেমন JCB 3DX)-এর RTO; crawler plant (Poclain, dozer) শুধু সাইটে — RTO passing নেই।',
  regMachineNameModel: 'মেশিনের নাম / মডেল',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — সাইট plant, RTO passing নেই',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) সহ নির্মাণ plant',
  machineFinancialSection: 'যন্ত্ৰ ক্ৰয়ৰ সবিশেষ (ঐচ্ছিক)',
  machineOwnershipType: 'মালিকানাৰ প্ৰকাৰ',
  machineOwnershipNew: 'নতুন যন্ত্ৰ',
  machineOwnershipUsed: 'মূল গৰাকী',
  machineOwnershipSecondHand: 'পূৰ্ব-গৰাকীত্ব',
  machinePurchasePrice: 'ক্ৰয় মূল্য (₹)',
  machinePurchasePriceHint: 'এই যন্ত্ৰৰ বাবে আপুনি দিয়া পৰিমাণ',
  machinePurchaseDate: 'ক্ৰয় তাৰিখ',
  machineYearOfManufacture: 'উৎপাদনৰ বছৰ',
  machineLoanSection: 'এই যন্ত্ৰত মোৰ loan আছে',
  machineLoanAmount: 'Loan পৰিমাণ (₹)',
  machineLoanEmi: 'মাহেকীয় EMI (₹)',
  machineLoanTenure: 'Loan সময় (মাহ)',
  machineLoanStartDate: 'Loan আৰম্ভ তাৰিখ',
  machineFuelConsumption: 'ইন্ধন খৰচ (L/hr)',
  machineMonthlyOperatingExpenses: 'মাহেকীয়া পৰিচালনা ব্যয়',
  machineOperatorMonthlySalary: 'অপাৰেটৰ মাহেকীয়া দৰমহা',
  machineServiceMonthly: 'চাৰ্ভিছ / ৰক্ষণাবেক্ষণ (মাহেকীয়া)',
  machineBreakdownMonthly: 'ব্ৰেকডাউন / মেৰামতি (মাহেকীয়া গড়)',
  machineMaterialsMonthly: 'সামগ্ৰী / ব্যৱহাৰযোগ্য (মাহেকীয়া)',
  recoveryPlan: 'ৰিকভাৰী প্লান',
  recoveryOnTrack: 'শুদ্ধ পথত',
  recoveryNeedsAttention: 'মনোয়গ প্ৰয়োজন',
  recoveryActionRequired: 'পদক্ষেপ প্ৰয়োজন',
  recoveryAddPrice: 'ৰিকভাৰী প্লান চাবলৈ ক্রয় মূল্য যোগ কৰক',
  recoveryProgress: 'বিনিয়োগ উদ্ধার',
  recoveryDailyNet: 'দৈনিক নিট আয়',
  recoveryDays: 'পুনৰুদ্ধাৰ সময়কাল',
  recoveryProjectedDate: 'অনুমানিত পুনৰুদ্ধাৰ তাৰিখ',
  recoveryRoi: 'বাৰ্ষিক ৰিটাৰ্ণ',
  recoveryCurrentValue: 'বৰ্তমান মেচিন মূল্য',
  editFinancialDetails: 'আৰ্থিক বিৱৰণ সম্পাদনা কৰক',
  financialDetailsSaved: 'আৰ্থিক বিৱৰণ সংৰক্ষিত',
  recoveryBackfillNudge: 'ৰিকভাৰি ট্ৰেকিং আনলক কৰিবলৈ {{count}}টা মেচিনত ক্ৰয়ৰ বিৱৰণ যোগ কৰক',
  dieselPriceTitle: 'ডিজেলৰ দাম',
  dieselPriceUpdate: 'ডিজেলৰ দাম আপডেট কৰক',
  dieselPriceLatest: 'শেহতীয়া দাম',
  dieselPriceNoRecord: 'ডিজেলৰ দাম ৰেকৰ্ড নাই',
  dieselPricePerLitre: 'লিটাৰ দাম (₹)',
  dieselQuantity: 'ভৰা পৰিমাণ (লিটাৰ)',
  dieselTaluka: 'চহৰ / অঞ্চল',
  bookingAttachment: 'এটাচমেণ্ট বাছক',
  bookingAttachmentNone: 'কোনো নিৰ্দিষ্ট এটাচমেণ্ট নাই',
  bookingWorkDescription: 'কামৰ বিৱৰণ',
  bookingWorkDescriptionPlaceholder: 'যেনে ভিত্তি খন্দা, ট্ৰেঞ্চিং, পাইপলাইন কাম',
  bookingAttachmentLabel: 'এটাচমেণ্ট',
  bookingSiteLabel: 'ছাইট',
  bookingWorkLabel: 'কাম',
  termsAccept: "মই চৰ্তাৱলীৰ সৈতে একমত",
  termsRequired: "পঞ্জীয়নৰ বাবে চৰ্তাৱলী মানি লোৱা প্ৰয়োজন",
  termsLink: "চৰ্তাৱলী",
  clientBlacklisted: "ব্লেকলিষ্ট",
  clientBlacklistReason: "ব্লেকলিষ্টৰ কাৰণ",
  clientBlacklistConfirm: "এই ক্লায়েন্টক ব্লেকলিষ্ট কৰিবনে?",
  clientUnblacklist: "ব্লেকলিষ্টৰ পৰা আঁতৰাওক",
  blacklistedClients: "ব্লেকলিষ্ট ক্লায়েন্ট",
  blacklistedClientsEmpty: "কোনো ব্লেকলিষ্ট ক্লায়েন্ট নাই",
  managerAccessRestricted: "বিত্তীয় প্ৰৱেশ সীমিত। ওম চৱানৰ সৈতে যোগাযোগ কৰক।",
  managerSection: "মেনেজাৰ",
  managerAdd: "মেনেজাৰ যোগ কৰক",
  managerName: "মেনেজাৰৰ নাম",
  managerEmail: "মেনেজাৰ ইমেইল",
  managerPassword: "অস্থায়ী পাছৱৰ্ড",
  managerCreated: "মেনেজাৰ একাউণ্ট সৃষ্টি হ’ল",
  managerCredentialsTitle: "মেনেজাৰ লগইন বিৱৰণ",
  managerCredentialsSubtitle: "এই বিৱৰণ এতিয়া সংৰক্ষণ কৰক — পাছৱৰ্ড পিছত উদ্ধাৰ কৰিব নোৱাৰি",
  managerCredentialsSaved: "মই বিৱৰণ সংৰক্ষণ কৰিলোঁ",
  managerLoginUrl: "লগইন URL",
  managerActivity: "মেনেজাৰ কাৰ্যকলাপ",
  managerActivityEmpty: "এতিয়ালৈকে কোনো কাৰ্যকলাপ লিপিবদ্ধ হোৱা নাই",
  managerActivityViewAll: "সকলো কাৰ্যকলাপ চাওক",
  onboardingTitle: "আৰম্ভ কৰক",
  onboardingAccountApproved: "একাউণ্ট অনুমোদিত",
  onboardingKycComplete: "KYC পৰীক্ষা সম্পূৰ্ণ",
  onboardingKycPending: "KYC পৰীক্ষা সম্পূৰ্ণ কৰক",
  onboardingKycRejected: "KYC প্ৰত্যাখ্যান — পুনৰ দাখিল কৰক",
  onboardingWalletFunded: "ৱালেটত বেলেন্স আছে",
  onboardingWalletEmpty: "বুকিংৰ বাবে ৱালেট বেলেন্স যোগ কৰক",
  pushEnablePrompt: "তাৎক্ষণিক আপডেটৰ বাবে পুছ জাননী চালু কৰক",
  downloadDisputeStatement: "বিবাদ বিবৃতি ডাউনলোড কৰক",
  downloadInvoice: "ইনভইচ ডাউনলোড কৰক",
  bookAgain: "পুনৰ বুকিং কৰক",
  machineNoLongerAvailable: "যন্ত্ৰ আৰু উপলব্ধ নহয়",
  downloadHistoryPdf: "ইতিহাস PDF ডাউনলোড কৰক",
  onboardingFirstBooking: "আপোনাৰ প্ৰথম বুকিং কৰক",
  onboardingAllDone: "আপুনি সাজু!",
  onboardingTrackerTitle: "অনবৰ্ডিং অগ্ৰগতি",
  onboardingTrackerTarget: "অনবৰ্ডিং লক্ষ্য: 48 ঘণ্টা",
  onboardingTrackerInProgress: "চলি আছে",
  onboardingTrackerActionRequired: "ব্যৱস্থাৰ প্ৰয়োজন",
  onboardingTrackerComplete: "সম্পূৰ্ণ",
  onboardingTrackerPending: "বাকী",
  onboardingTrackerPhase1: "পঞ্জীয়ন",
  onboardingTrackerPhase2: "KYC পৰীক্ষা",
  onboardingTrackerPhase3: "মেচিন পঞ্জীয়ন",
  onboardingTrackerPhase4: "প্ৰথম বুকিং সাজু",
  onboardingTrackerHelper1: "মেচিন পঞ্জীয়ন খুলিবলৈ আধাৰ + ছেলফি আপলোড কৰক",
  onboardingTrackerHelper2: "KYC সমীক্ষাত — সাধাৰণতে 24 ঘণ্টাত",
  onboardingTrackerHelper3: "KYC প্ৰত্যাখ্যান — নথি পুনৰ দাখিল কৰক",
  onboardingTrackerHelper4: "KYC অনুমোদিত — আপোনাৰ প্ৰথম মেচিন যোগ কৰক",
  onboardingTrackerHelper5: "মেচিন এডমিন সমীক্ষাত",
  onboardingTrackerHelper6: "মেচিন লাইভ — প্ৰথম বুকিংৰ অপেক্ষা",
  onboardingTrackerPhaseLabel: "পৰ্যায়",
  alertsAndNotifications: 'সতৰ্কতা আৰু জাননী',
  dieselFuelCostPerHour: 'ঘণ্টাৰ ইন্ধন খৰচ',
  dieselPercentOfRate: 'আপোনাৰ ঘণ্টাৰ দৰৰ',
  dieselPriceSaved: 'ডিজেলৰ দাম সংৰক্ষিত',
  dieselRateSuggestion: 'দৰ পৰামৰ্শ',
  dieselRateIncrease: 'ডিজেল বৃদ্ধি — দৰ বঢ়োৱাৰ কথা চিন্তা কৰক',
  dieselRateDecrease: 'ডিজেল কমা — বুকিঙৰ বাবে দৰ কমাওক',
  dieselSuggestedRate: 'পৰামৰ্শিত দৰ',
  dieselHistory: 'দামৰ ইতিহাস',
  dieselNoHistory: 'এতিয়ালৈকে ডিজেল দামৰ ইতিহাস নাই',
  dieselColDate: 'তাৰিখ',
  dieselColPrice: 'দাম/লিটাৰ',
  dieselColQty: 'পৰিমাণ',
  dieselColSource: 'উৎস',
  dieselUploadReceipt: 'ৰসিদ আপলোড',
  dieselExtractSuccess: 'ৰসিদৰ পৰা উলিয়াইছে',
  dieselExtractFailed: 'উলিয়াব পৰা নগল — মেনুৱেলি লিখক',
  applyRateSuggestion: '₹{{rate}}/ঘণ্টা প্ৰয়োগ কৰক',
  rateSuggestionApplied: 'দৰ সফলভাৱে আপডেট হল',
  marketPosition: 'বজাৰ অৱস্থান',
  marketBelowMarket: 'বজাৰতকৈ কম',
  marketCompetitive: 'প্ৰতিযোগিতামূলক',
  marketAboveMarket: 'বজাৰতকৈ বেছি',
  marketNoData: 'আপোনাৰ অঞ্চলৰ বাবে এতিয়াও বজাৰ তথ্য নাই',
  marketSubmitRate: 'বজাৰ দৰ জমা দিয়ক',
  marketCity: 'চহৰ / অঞ্চল',
  marketMinRate: 'আপোনাৰ অঞ্চলত সৰ্বনিম্ন দৰ (₹/ঘণ্টা)',
  marketMaxRate: 'আপোনাৰ অঞ্চলত সৰ্বোচ্চ দৰ (₹/ঘণ্টা)',
  marketRateSubmitted: 'বজাৰ দৰ জমা হৈছে — ধন্যবাদ!',
  marketDataPoints: '{{count}} জমাৰ ওপৰত ভিত্তি কৰি',
  marketRange: '{{city}} ত বজাৰ',
  marketSourceLocal: '{{city}} অঞ্চলৰ হাৰৰ ওপৰত ভিত্তি কৰি',
  marketSourcePlatform: 'প্লেটফৰ্ম-ব্যাপী হাৰৰ ওপৰত ভিত্তি কৰি',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO নিবন্ধন নম্বর *',
  regSelectType: 'ধরন নির্বাচন করুন…',
  regSubmitBtn: '✅ নিবন্ধন জমা দিন',
  regTagNoRto: 'RTO নেই',
  regTagRto: 'RTO',
  regYearManufacture: 'উৎপাদনের বছর *',
  register: 'মেশিন নিবন্ধন',
  registerAction: 'নিবন্ধন করুন',
  registerMachine: 'মেশিন নিবন্ধন',
  registering: 'নিবন্ধন হচ্ছে...',
  registrationPending: 'অ্যাডমিন ২৪ ঘণ্টার মধ্যে আপনার অ্যাকাউন্ট সক্রিয় করবেন।',
  registrationSuccess: 'নিবন্ধন সফল!',
  remoteLockAlert: 'Teltonika GPS device এই মেশিনে ইনস্টল হলে remote lock সক্রিয় হবে। DE support-এ যোগাযোগ করুন।',
  remoteLockMachine: '🔒 রিমোট লক মেশিন',
  replaceFile: 'পরিবর্তন',
  reportText: 'রিপোর্ট',
  reports: 'ৰিপোৰ্ট',
  resetMethodEmail: 'ইমেইল লিংক',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'পাসওয়ার্ড রিসেট করতে ব্যর্থ। নতুন লিংক অনুরোধ করুন।',
  resetPasswordIntro: 'ন্যূনতম ৮ অক্ষরের শক্তিশালী পাসওয়ার্ড বেছে নিন।',
  resetPasswordMinLength: 'পাসওয়ার্ড ন্যূনতম ৮ অক্ষর হতে হবে।',
  resetPasswordMissingToken: 'রিসেট লিংক নেই বা অবৈধ। লগইন থেকে Forgot password ব্যবহার করুন।',
  resetPasswordSubmit: 'পাসওয়ার্ড আপডেট করুন',
  resetPasswordSuccess: 'পাসওয়ার্ড আপডেট হয়েছে। লগইনে ফিরছে...',
  resetPasswordTitle: 'নতুন পাসওয়ার্ড সেট করুন',
  resetPasswordUpdating: 'আপডেট হচ্ছে...',
  resetText: 'রিসেট',
  retryDlqItemTitle: 'DLQ আইটেম পুনরায় চেষ্টা করুন',
  retryFailedForDlq: 'DLQ আইটেমের জন্য পুনরায় চেষ্টা ব্যর্থ',
  retryReasonAuditPlaceholder: 'পুনরায় চেষ্টার কারণ (অডিটের জন্য)',
  retryText: 'আবার চেষ্টা করুন',
  revenue: 'আয়',
  running: 'চলছে',
  satisfiedNo: 'অসন্তুষ্ট',
  satisfiedYes: 'হ্যাঁ, সন্তুষ্ট',
  save: 'সংরক্ষণ',
  scanToPay: 'পেমেন্টের জন্য স্ক্যান করুন',
  scheduleColFeedback: 'প্রতিক্রিয়া',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'মোট',
  scheduleColType: 'ধরন',
  securitySignalsTitle: 'নিরাপত্তা সংকেত',
  selectBook: 'এই মেশিন বুক করুন →',
  selectCalc: '📋 নির্বাচন ও খরচ দেখুন →',
  selectFile: 'ফাইল নির্বাচন',
  selectMachineFirst: 'প্রথমে মেশিন নির্বাচন করুন',
  selectQty: 'পরিমাণ নির্বাচন',
  selectRole: 'ভূমিকা বাছক',
  selectedMachineText: 'নির্বাচিত মেশিন',
  send: 'পাঠান',
  sendEmail: 'ইমেইল পাঠান',
  sendWhatsapp: 'WhatsApp-এ পাঠান',
  settlements: 'নিষ্পত্তি',
  show: 'দেখান',
  signIn: 'ছাইন ইন',
  signingIn: 'লগইন হৈ আছে...',
  signupCompanyName: 'কোম্পানির নাম',
  signupContactName: 'যোগাযোগের নাম',
  signupCreatePassword: 'পাসওয়ার্ড তৈরি করুন',
  signupReenterPassword: 'পাসওয়ার্ড আবার লিখুন',
  signupSectionCompany: 'কোম্পানি',
  signupSectionContact: 'আপনার বিবরণ',
  signupSectionSecurity: 'নিরাপত্তা',
  sinceExcellence: '২০১১ থেকে · ১৫ বছরের শ্রেষ্ঠত্ব',
  sinceLabel: 'থেকে',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'গতি',
  staleText: 'পুরনো',
  status: 'অবস্থা',
  statusCancelled: 'বাতিল',
  bookingClosed: 'বন্ধ',
  sectionNew: 'নতুন',
  sectionAccepted: 'গ্ৰহণ কৰা',
  sectionActive: 'সক্ৰিয়',
  sectionDispatched: 'ডিস্পেচ',
  sectionCompleting: 'সম্পূৰ্ণ হৈ আছে',
  sectionDisputed: 'বিবাদ',
  sectionCompleted: 'সম্পন্ন',
  sectionClosed: 'বন্ধ',
  statusCompleted: 'সম্পন্ন',
  stopped: 'থেমেছে',
  submit: 'জমা দিন',
  submitOperatorFeedback: 'প্রতিক্রিয়া জমা দিন',
  submittedRegistrations: 'জমা দেওয়া নিবন্ধন',
  support: 'সহায়',
  supportPolicyBooking: 'শুধু ওয়ালেট অগ্রিম। সাইটে নগদ নয়।',
  supportPolicyCancellation: '১ ঘণ্টা জরিমানা; বাকি ওয়ালেটে।',
  supportPolicyContact: 'শুধু DE Support — সরাসরি অপারেটর যোগাযোগ নিষিদ্ধ।',
  supportPolicyGst: 'সব ইনভয়েসে 18% GST; Reports ট্যাবে ডাউনলোড।',
  supportPolicyHours: 'সোম–শনি, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'পরিবর্তন',
  tableDay: 'দিন',
  tableEnd: 'শেষ',
  tableHrs: 'ঘণ্টা',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'স্তর',
  tableMonth: 'মাস',
  tableNote: 'নোট',
  tableOut: 'Out',
  tableStart: 'শুরু',
  tagline: 'আন্তঃগাঁথনিৰ সোণালী মান',
  tax: 'কর',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express কমিশন: মোট বিলিংয়ের ১৫%',
  termFuel: 'মেশিনে সবসময় ৪০%+ জ্বালানি থাকতে হবে',
  termGps: 'GPS device (Teltonika) বাধ্যতামূলক — DE দ্বারা ইনস্টল',
  termGstTcs: 'GST TCS: GST regulations অনুযায়ী ১%',
  termNoDirectContact: 'সরাসরি গ্রাহক যোগাযোগ = তাৎক্ষণিক contract termination',
  termPaymentDays: 'গ্রাহক settlement-এর ৩ কার্যদিবসের মধ্যে পেমেন্ট',
  termTds: 'TDS deduction: Income Tax Act অনুযায়ী ২%',
  threeWorkingDays: '৩ কার্যদিবস',
  timeLabel: 'সময়',
  todayText: 'আজ',
  topSourceIp: 'শীর্ষ সোর্স IP',
  total: 'মোট',
  totalAdvanceLabel: 'অগ্রিম প্রদত্ত',
  totalBookingsText: 'মোট বুকিং',
  totalMachines: 'মোট মেশিন',
  totalSpent: 'মোট খরচ',
  tracking: 'GPS ট্র্যাকিং',
  transactionHistoryTitle: 'লেনদেন ইতিহাস',
  transactions: 'লেনদেন ইতিহাস',
  trustStatCompliant: 'সম্মতি',
  trustStatMachines: 'মেশিন',
  trustStatRating: 'রেটিং',
  txnDescription: 'বিবরণ',
  type: 'ধরন',
  understood: '✅ বুঝেছি — প্ল্যাটফর্ম ব্যবহার করব',
  understoodAction: 'বুঝেছি',
  unknownText: 'অজানা',
  updateFuel: 'জ্বালানি আপডেট',
  updateText: 'আপডেট',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'আপলোড',
  valEmail: 'বৈধ ইমেইল প্রয়োজন',
  valMachineName: 'মেশিনের নাম / model প্রয়োজন',
  valMachineType: 'অনুগ্রহ করে equipment category নির্বাচন করুন',
  valMobility: 'অনুগ্রহ করে wheeled বা crawler equipment ধরন নির্বাচন করুন',
  valOwnerName: 'মালিকের নাম প্রয়োজন',
  valPdiChecks: 'অনুগ্রহ করে সমস্ত required checks নিশ্চিত করুন',
  valPdiRequired: 'PDI confirmation প্রয়োজন',
  valPhone: 'বৈধ ফোন নম্বর প্রয়োজন',
  valRto: 'Wheeled machines-এর জন্য RTO registration number প্রয়োজন',
  valUploadMissing: 'অনুগ্রহ করে আপলোড করুন: {docs}',
  valYear: 'বৈধ year (YYYY) প্রয়োজন',
  viewMachines: '→ মেশিন দেখুন',
  wallet: 'ৱালেট',
  walletBalance: 'ৱালেট বেলেন্স',
  walletCredit: 'ওয়ালেট ক্রেডিট',
  walletDebit: 'ওয়ালেট ডেবিট',
  walletDeduct: 'অগ্রিম ওয়ালেট থেকে কাটা হবে · নগদ নয় · GST স্বয়ংক্রিয়ভাবে তৈরি',
  walletInsufficient: '❌ অপর্যাপ্ত',
  walletLowRecharge: 'ওয়ালেট ব্যালেন্স কম — পরবর্তী বুকিংয়ের আগে রিচার্জ',
  walletOnly: 'কেৱল ৱালেট · নগদ গ্ৰহণ নকৰে',
  walletOnlyPolicyDesc: 'সমস্ত লেনদেন শুধুমাত্র ওয়ালেটের মাধ্যমে। নগদ গ্রহণযোগ্য নয়।',
  walletOnlyPolicyTitle: 'শুধুমাত্র ওয়ালেট নীতি',
  walletRechargeTitle: 'ওয়ালেট রিচার্জ',
  walletSufficient: '✅ চালিয়ে যান',
  weeks: 'সপ্তাহ',
  whatsapp: 'WhatsApp',
  wksUnit: 'সপ্তাহ',
  year: 'বছর',
  yearsExperience: '{n} বছর',
  yourMessage: 'আপনার প্রশ্ন বা সমস্যা লিখুন...',
  // --- Recent feature strings ---
  retryLabel: 'আকৌ চেষ্টা কৰক',
  payrollPreview: 'পগাৰ পূৰ্বদৰ্শন',
  payrollRun: 'পগাৰ চলাওক',
  payrollAlreadyRun: 'এই মাহৰ বাবে পগাৰ ইতিমধ্যে চলোৱা হৈছে',
  payrollGross: 'মুঠ পৰিশোধযোগ্য',
  payrollNet: 'নিট পৰিশোধযোগ্য',
  payrollAdvanceDeducted: 'অগ্ৰিম কাটা',
  payrollRunSuccess: 'পগাৰ সফলতাৰে চলোৱা হৈছে',
  payrollNoAmount: 'এই মাহৰ বাবে পৰিশোধযোগ্য ধন নাই',
  payrollMonth: 'পগাৰ মাহ',
  exportPayrollCsv: 'পগাৰ CSV এক্সপোৰ্ট',
  payrollExportMonth: 'পগাৰ এক্সপোৰ্ট মাহ',
  payrollDailyRate: 'দৈনিক হাৰ',
  payrollHistory: 'পগাৰ ইতিহাস',
  payrollNoHistory: 'এতিয়ালৈকে কোনো পগাৰ চলোৱা হোৱা নাই',
  payrollColMonth: 'মাহ',
  payrollColGross: 'মুঠ',
  payrollColDeduction: 'অগ্ৰিম কাট',
  payrollColNet: 'নেট পগাৰ',
  payrollColDate: 'তাৰিখ',
  downloadPayslip: 'পে স্লিপ ডাউনলোড',
  payslipTitle: 'মাহেকীয় পে স্লিপ',
  payslipEarnings: 'আয়',
  payslipDeductions: 'কাট',
  payslipDaysWorked: 'কামৰ দিন',
  payslipGeneratedBy: 'Development Express ৰ দ্বাৰা প্ৰস্তুত',
  operatorPayrollTitle: 'মোৰ বেতন',
  payrollMonthlySalary: 'মাহেকীয় বেতন',
  payrollCurrentMonth: 'বৰ্তমান মাহ',
  payrollPreviousMonth: 'আগৰ মাহ',
  ownerAttendanceTitle: 'উপস্থিতি',
  ownerAttendanceEdit: 'সম্পাদনা',
  ownerAttendanceSave: 'সংৰক্ষণ',
  ownerAttendanceNoRecords: 'এই মাহৰ বাবে উপস্থিতি ৰেকৰ্ড নাই',
  ownerAttendanceOverrideSuccess: 'উপস্থিতি আপডেট হ’ল',
  ownerSalaryUpdated: 'বেতন সফলভাৱে আপডেট হ’ল',
  ownerSalaryEditBtn: 'বেতন সম্পাদনা',
  ownerSalaryNotSet: 'বেতন ছেট নাই — পেৰোলৰ বাবে বেতন ছেট কৰক',
  duration: "সময়সীমা",
  durationLabel: 'সময়সীমা',
  plQuotaLabel: 'PL কোটা',
  plUsed: 'ব্যৱহৃত',
  plAllowed: 'অনুমোদিত',
  plRemaining: 'বাকী',
  plQuotaUpdated: 'PL কোটা আপডেট',
  plQuotaExhausted: 'PL কোটা শেষ — অবৈতনিক ছুটি হিসেবে চিহ্নিত',
  plRemainingLabel: 'বাকি PL',
  noAttendanceRecords: 'এতিয়ালৈকে উপস্থিতি ৰেকৰ্ড নাই',
  noFuelLogs: 'এতিয়ালৈকে ইন্ধন লগ নাই',
  noIssuesYet: 'এতিয়ালৈকে কোনো সমস্যা ৰেকৰ্ড নাই',
  failedToLoad: 'ডাটা লোড কৰিব পৰা নগ’ল',
  failedToLoadReport: 'ৰিপৰ্ট লোড কৰিব পৰা নগ’ল',
  failedToLoadIssues: 'সমস্যা লোড কৰিব পৰা নগ’ল',
  failedToLoadAlerts: 'সতৰ্কতা লোড কৰিব পৰা নগ’ল',
  noRecordsMonth: 'এই মাহত ৰেকৰ্ড নাই',
  underReview: 'পৰ্যালোচনাধীন',
  issueResolved: 'সমাধান হ’ল',
  presentDaysLabel: 'উপস্থিত দিন',
  halfDaysLabel: 'আধা দিন',
  absentDaysLabel: 'অনুপস্থিত দিন',
  totalHmrLabel: 'মুঠ HMR',
  noActiveBookingIdle: 'কোনো সক্ৰিয় বুকিং নাই — মেচিন নিষ্ক্ৰিয়',
  siteLocationNotCaptured: 'ছাইট স্থান ৰেকৰ্ড হোৱা নাই',
  siteLocationNotAvailable: 'ছাইট স্থান উপলব্ধ নহয়',
  bookingRefLabel: 'বুকিং Ref',
  alertPendingBookings: 'বাকী বুকিং',
  alertPendingPayouts: 'বাকী পেমেণ্ট',
  alertLowFuel: 'কম ইন্ধন',
  alertOpenIssues: 'খোলা সমস্যা',
  noMachineRunning: 'বৰ্তমান কোনো মেচিন চলি নাই',
  trackingEmptyHint: 'মেচিন পঠোৱাৰ পিছত আপোনাৰ সক্ৰিয় বুকিং ইয়াত দেখা যাব।',
  trackingUpdatedEvery5s: 'প্ৰতি ৫ ছেকেণ্ডত আপডেট',
  fuelLastOperatorUpdate: '(অপাৰেটৰৰ শেষ আপডেট)',
  alertExtensionPending: 'বুকিং বিস্তাৰ বাকী',
  alertConfirmCompletion: 'অনুগ্ৰহ কৰি কাম সম্পূৰ্ণ নিশ্চিত কৰক',
  alertWalletCredited: 'ৱালেটত যোগ হ’ল',
  alertFeedbackRequest: 'কাম সম্পূৰ্ণ — আপোনাৰ মতামত শ্বেয়াৰ কৰক',
  noLogsYet: 'এতিয়ালৈকে কোনো কাৰ্যকলাপ লগ হোৱা নাই',
  todayActivityLog: 'আজিৰ কাৰ্যকলাপ লগ',
  machineLogSubtitle: 'ইন্ধন, উপস্থিতি, সমস্যা — স্থানীয় ছেশন লগ',
  timerPaused: 'Timer ৰখা হৈছে',
  liveBookingTitle: 'লাইভ বুকিং',
  machineLogTimerHint: 'Timer Admin আৰম্ভ কৰে। তলত আপোনাৰ প্ৰকৃত কামৰ সময় লিখক — শেষত Mark Work Complete ক্লিক কৰক।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'উপস্থিতি',
  ownerAlertBookingPending: 'নতুন বুকিং আপোনাৰ অনুমোদনৰ বাবে বাকী —',
  ownerAlertBookingHours: 'ঘণ্টা',
  ownerAlertPayoutPending: '₹{{amount}} পেমেণ্ট স্থানান্তৰ বাকী',
  ownerAlertFuelLow: 'ইন্ধন কম',
  ownerAlertFuelRemaining: 'বাকী',
  ownerAlertIssue: 'সমস্যা পঞ্জীয়ন',
  iotGpsDevicesActive: 'GPS ডিভাইচ সক্ৰিয়',
  iotDashcamsOnline: 'ড্যাশকেম অনলাইন',
  iotFuelSensorsActive: 'ইন্ধন চেন্সৰ সক্ৰিয়',
  iotMachinesLocked: 'মেচিন লক',
  iotDeviceStatus: 'IoT ডিভাইচ স্থিতি',
  iotColMachine: 'মেচিন',
  iotColGps: 'GPS',
  iotColLocation: 'স্থান',
  iotColFuel: 'ইন্ধন %',
  iotColDashcam: 'ড্যাশকেম',
  iotColIgnition: 'ইগনিশন',
  iotColAction: 'কাৰ্য',
  iotStatusOnline: 'অনলাইন',
  iotStatusNotConnected: 'সংযুক্ত নহয়',
  iotStatusLive: 'লাইভ',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'লক',
  iotNotConnectedBanner: 'IoT হাৰ্ডৱেৰ এতিয়ালৈকে ইনষ্টল হোৱা নাই। Teltonika ডিভাইচ ইনষ্টলেচনৰ পিছত GPS, ড্যাশকেম আৰু ৰিমোট লক সুবিধা উপলব্ধ হ’ব।',
  fuelUpdateTitle: 'ইন্ধন আপডেট',
  fuelSensorAccuracyNote: 'অপাৰেটৰে লগ কৰা ইন্ধনৰ স্তৰ · ম্যানুৱেল প্ৰৱেশ',
  bookingsTab: 'বুকিং',
  unknownLabel: 'অজ্ঞাত',
  naLabel: 'N/A',
  baseLabel: 'ভিত্তি',
  qtyLabel: 'পৰিমাণ',
  actualHrsLabel: 'প্ৰকৃত ঘণ্টা',
  auditStatTotal: 'মুঠ',
  auditStatSecurity: 'নিরাপত্তা',
  auditStatActors: 'কৰ্তা',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'লাইচেন্স',
  kycDocAadhaarFront: 'Aadhaar সন্মুখ',
  kycDocAadhaarBack: 'Aadhaar পিছফাল',
  kycDocPoliceVerification: 'আৰক্ষী পৰীক্ষা',
  kycVerification: 'KYC পৰীক্ষা',
  kycNotSubmitted: 'KYC দাখিল কৰা হোৱা নাই',
  kycUnderReview: 'KYC পৰ্যালোচনাধীন',
  kycVerified: 'KYC পৰীক্ষিত',
  kycRejected: 'KYC প্ৰত্যাখ্যান',
  kycAadhaarFront: 'Aadhaar সন্মুখ',
  kycAadhaarBack: 'Aadhaar পিছফাল',
  kycSelfie: 'ছেল্ফি',
  kycSubmitBtn: 'KYC নথি দাখিল কৰক',
  kycSubmitSuccess: 'নথি দাখিল — পৰ্যালোচনাধীন',
  kycResubmit: 'পুনৰ নথি দাখিল কৰক',
  adminKycTitle: 'ক্লায়েন্ট KYC পৰ্যালোচনা',
  adminKycAllFilter: 'সকলো',
  adminKycNoSubmissions: 'এতিয়ালৈ KYC দাখিল নাই',
  adminOwnerKycTitle: 'মালিক KYC পৰ্যালোচনা',
  adminOwnerKycNoSubmissions: 'এতিয়ালৈ কোনো মালিক KYC দাখিল নাই',
  adminOperatorKycTitle: 'অপাৰেটৰ KYC পৰ্যালোচনা',
  adminOperatorKycNoSubmissions: 'এতিয়ালৈ কোনো অপাৰেটৰ KYC দাখিল নাই',
  kycRejectedWarning: 'আপোনাৰ KYC নাকচ কৰা হৈছে। অনুগ্ৰহ কৰি নথি পুনৰ দাখিল কৰক।',
  kycNotSubmittedHint: 'বিশ্বাসযোগ্য অভিজ্ঞতাৰ বাবে KYC সম্পূৰ্ণ কৰক।',
  kycPendingHint: 'আপোনাৰ KYC পৰ্যালোচনাধীন।',
  kycGoToTab: 'KYC লৈ যাওক',
  adminKycApproveBtn: 'অনুমোদন',
  adminKycRejectBtn: 'প্ৰত্যাখ্যান',
  adminKycViewDocs: 'নথি চাওক',
  adminKycRejectReason: 'প্ৰত্যাখ্যানৰ কাৰণ',
  adminKycRereviewBtn: 'পুনৰ পৰ্যালোচনা',
  kycPan: 'PAN কাৰ্ড',
  kycOwnerSubmitSuccess: 'নথি জমা — আপোনাৰ KYC পৰ্যালোচনাধীন',
  kycLicense: 'ড্ৰাইভিং লাইচেন্স',
  kycPoliceVerification: 'আৰক্ষী পৰীক্ষা',
  kycOperatorSubmitSuccess: 'নথি জমা — আপোনাৰ KYC পৰ্যালোচনাধীন',
  operatorKycRejectedAssign: 'এই অপাৰেটৰৰ KYC নাকচ কৰা হৈছে — পুনৰ অনুমোদন নোহোৱালৈকে তেওঁলোকক নিযুক্তি দিয়া নহ\'ব।',
  operatorsColOperator: 'অপাৰেটৰ',
  operatorsColEmail: 'ইমেইল',
  operatorsColPhone: 'ফোন',
  operatorsColDocuments: 'নথি',
  operatorsColStatus: 'স্থিতি',
  operatorsDocumentsBtn: 'নথি ({{count}})',
  operatorsNoResults: 'কোনো অপাৰেটৰ পোৱা নগ\'ল',
  operatorsAllTitle: 'সকলো অপাৰেটৰ ({{count}})',
  operatorsKycDialogDesc: 'KYC নথি',
  bookingsCountLabel: '{{count}} বুকিং',
  complianceDates: 'অনুপালন তাৰিখ',
  complianceInsurance: 'বীমা',
  complianceRcBook: 'RC কিতাপ',
  compliancePuc: 'PUC',
  complianceNotSet: 'ছেট নাই',
  complianceExpired: 'ম্যাদ উকলিল',
  complianceExpiringSoon: 'শীঘ্ৰে ম্যাদ উকলিব',
  complianceExpiringCritical: '৭ দিনত ম্যাদ',
  complianceValid: 'বৈধ',
  complianceUpdateBtn: 'অনুপালন তাৰিখ আপডেট কৰক',
  complianceSaveBtn: 'সংৰক্ষণ',
  complianceAlertsTitle: 'অনুপালন সতৰ্কতা',
  complianceAllCompliant: 'সকলো মেচিন অনুপালনত ✅',
  complianceColMachine: 'মেচিন',
  complianceColOwner: 'মালিক',
  complianceColInsurance: 'বীমা',
  complianceColRcBook: 'RC কিতাপ',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'আৰম্ভণিৰ তাৰিখ',
  complianceEndDate: 'শেষ তাৰিখ',
  complianceExtractBtn: 'তাৰিখ স্বয়ংক্ৰিয়ভাৱে ভৰাবলৈ নথি আপলোড কৰক',
  complianceExtractSuccess: 'তাৰিখ উলিয়াই লোৱা হ\'ল — সংৰক্ষণৰ আগতে পৰীক্ষা কৰক',
  complianceExtractError: 'তাৰিখ উলিয়াব পৰা নগ\'ল — অনুগ্ৰহ কৰি হাতেৰে লিখক',
  complianceExtracting: 'নথি পঢ়ি আছে...',
  serviceHistory: 'সেৱা ইতিহাস',
  serviceLastService: 'শেষ সেৱা',
  serviceNoRecords: 'এতিয়ালৈকে কোনো সেৱা ৰেকৰ্ড নাই',
  serviceNextDue: 'পৰৱৰ্তী সেৱা বাকী',
  serviceNextHmr: 'পৰৱৰ্তী সেৱাত',
  serviceAddLog: 'সেৱা লগ যোগ কৰক',
  serviceDate: 'সেৱা তাৰিখ',
  serviceType: 'সেৱা প্ৰকাৰ',
  serviceHmr: 'সেৱা HMR',
  serviceNextDate: 'পৰৱৰ্তী সেৱা তাৰিখ',
  serviceWorkDone: 'কৰা কাম',
  serviceNotes: 'টোকা',
  serviceTypeRoutine: 'নিয়মীয়',
  serviceTypeMajor: 'প্ৰধান',
  serviceTypeBreakdown: 'বিফল',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'অন্য',
  serviceOverdue: 'ম্যাদ উকলি গ’ল',
  serviceDueSoon: 'শীঘ্ৰে বাকী',
  fleetAnalytics: 'ফ্লিট বিশ্লেষণ',
  analyticsRevenue: 'মুঠ আয়',
  analyticsBookings: 'মুঠ বুকিং',
  analyticsHours: 'মুঠ ঘণ্টা',
  analyticsActiveMachines: 'সক্ৰিয় যন্ত্ৰ',
  analyticsMonthlyTrend: 'মাহেকীয় আয়ৰ প্রবণতা',
  analyticsMachineTable: 'যন্ত্ৰ অনুযায়ী আয়',
  analyticsNoData: 'এই সময়ছোৱাত কোনো সম্পূৰ্ণ বুকিং নাই',
  analyticsLastBooking: 'শেষ বুকিং',
  analytics3Months: '3 মাহ',
  analytics6Months: '6 মাহ',
  analytics12Months: '12 মাহ',
  adminAnalytics: 'বিশ্লেষণ',
  adminFleetTitle: 'ফ্লিট বিশ্লেষণ',
  adminFleetPlatformRevenue: 'প্লেটফৰ্ম আয়',
  adminFleetActiveOwners: 'সক্ৰিয় মালিক',
  adminFleetOwnerCol: 'মালিক',
  adminFleetMonthlyTrend: 'মাহেকীয় আয়ৰ প্ৰৱণতা',
  adminFleetMachineTable: 'যন্ত্ৰ অনুসৰি আয়',
  adminFleetNoData: 'এই সময়ছোৱাত কোনো সম্পূৰ্ণ বুকিং নাই',
  adminFinancialIntelligence: 'যন্ত্ৰৰ আৰ্থিক তথ্য',
  adminTotalInvested: 'মুঠ বিনিয়োগ',
  adminTotalEarned: 'মুঠ উপাৰ্জন',
  adminAvgRecovery: 'গড় পুনৰুদ্ধাৰ',
  adminBreakEvenRate: 'ব্ৰেক-ইভেন হাৰ',
  adminProfitMargin: 'লাভৰ মাৰ্জিন',
  adminNoFinancialData: 'এতিয়ালৈকে আৰ্থিক তথ্য থকা যন্ত্ৰ নাই',
  adminMachineDetail: 'যন্ত্ৰৰ বিৱৰণ',
  adminCallOwner: 'মালিকক ফোন কৰক',
  adminWhatsappOwner: 'WhatsApp মালিক',
  adminMarketRates: 'বজাৰ হাৰ জমা',
  adminMarketRateDelete: 'মচক',
  adminMarketRateDeleteConfirm: 'এই বজাৰ হাৰ জমা মচিবনে?',
  adminMarketRateDeleted: 'বজাৰ হাৰ মচা হ’ল',
  adminMarketRateNoData: 'এতিয়ালৈকে কোনো বজাৰ হাৰ জমা নাই',
  marketRateApprove: 'অনুমোদন কৰক',
  marketRateReject: 'প্ৰত্যাখ্যান কৰক',
  marketRateApproved: 'অনুমোদিত',
  marketRateRejected: 'প্ৰত্যাখ্যাত',
  marketRatePending: 'বাকী',
  marketRateReviewed: 'বজাৰ হাৰ পৰ্যালোচনা কৰা হৈছে',
  marketRatePendingReview: 'আপোনাৰ হাৰ জমা হৈছে আৰু এডমিন পৰ্যালোচনাৰ বাবে বাকী আছে।',
  marketRateEditApprove: 'সম্পাদনা আৰু অনুমোদন',
  marketRateEditMin: 'সংশোধিত ন্যূনতম হাৰ (₹/ঘণ্টা)',
  marketRateEditMax: 'সংশোধিত সৰ্বোচ্চ হাৰ (₹/ঘণ্টা)',
  adminPayrollOverview: 'পগাৰ সাৰাংশ',
  adminPayrollTotalOperators: 'মুঠ অপাৰেটৰ',
  adminPayrollTotalGross: 'মুঠ প্ৰদেয়',
  adminPayrollTotalNet: 'মুঠ নেট প্ৰদেয়',
  adminPayrollNoData: 'এই মাহত পগাৰ তথ্য নাই',
  subTabSchedule: 'সময়সূচী',
  subTabHistory: 'ইতিহাস',
  subTabAnalytics: 'বিশ্লেষণ',
  clientAnalyticsTitle: 'বুকিং বিশ্লেষণ',
  clientAnalyticsSpend: 'মুঠ খৰচ',
  clientAnalyticsHours: 'মুঠ ঘণ্টা',
  clientAnalyticsBookings: 'সম্পূৰ্ণ বুকিং',
  clientAnalyticsMachines: 'ব্যৱহৃত যন্ত্ৰ',
  clientAnalyticsAvgSpend: 'প্ৰতি বুকিং গড়',
  clientAnalyticsMonthlyTrend: 'মাহেকীয় খৰচৰ প্ৰৱণতা',
  clientAnalyticsTopMachines: 'শীৰ্ষ যন্ত্ৰ',
  clientAnalyticsNoData: 'এই সময়ছোৱাত কোনো সম্পূৰ্ণ বুকিং নাই',
  operatorAnalyticsTitle: 'কামৰ বিশ্লেষণ',
  operatorAnalyticsPresentDays: 'উপস্থিত দিন',
  operatorAnalyticsHalfDays: 'আধা দিন',
  operatorAnalyticsHmr: 'মুঠ HMR',
  operatorAnalyticsJobs: 'সম্পূৰ্ণ কাম',
  operatorAnalyticsIssues: 'ৰিপোৰ্ট কৰা সমস্যা',
  operatorAnalyticsAvgHmr: 'গড় HMR/দিন',
  operatorAnalyticsMonthlyTrend: 'মাহেকীয় কামৰ প্ৰবণতা',
  operatorAnalyticsIssueBreakdown: 'ধৰণ অনুযায়ী সমস্যা',
  operatorAnalyticsRecentJobs: 'শেহতীয়া কাম',
  operatorAnalyticsNoData: 'এই সময়ছোৱাত কামৰ ৰেকৰ্ড নাই',
  adminServiceAlertsTitle: 'সেৱা সতৰ্কতা',
  adminServiceAllOk: 'সকলো মেচিনৰ সেৱা ৰেকৰ্ড আপ-টু-ডেট ✅',
  adminServiceNoRecord: 'কোনো ৰেকৰ্ড নাই',
  adminServiceColLastService: 'শেষ সেৱা',
  adminServiceColNextDue: 'পৰৱৰ্তী Due',
  adminServiceColServiceStatus: 'সেৱা স্থিতি',
  adminMachinesColMinHrs: 'ন্যূনতম ঘণ্টা',
  adminMachinesColRateDay: 'দৰ/দিন',
  adminClientName: 'গ্ৰাহকৰ নাম',
  adminOwnerName: 'মালিকৰ নাম',
  adminPayoutWallet: 'পেআউট ৱালেট',
  adminFooterMachines: 'যন্ত্ৰ',
  adminFooterClients: 'ক্লায়েন্ট',
  adminFooterOwners: 'মালিক',
  auditSeverityCritical: 'গুৰুতৰ',
  auditSeverityHigh: 'উচ্চ',
  auditSeverityMedium: 'মধ্যম',
  auditSeverityNormal: 'সাধাৰণ',
  auditCopyEvent: 'ইভেন্ট কপি কৰক',
  auditViewDetails: 'বিৱৰণ চাওক',
  auditHideDetails: 'বিৱৰণ লুকুৱাওক',
  auditCopyJson: 'JSON কপি কৰক',
  auditNoLogs: 'কোনো অডিট লগ নাই',
  auditIntroBanner: 'লগইন, এডমিন কাৰ্য্য আৰু নিৰাপত্তা ঘটনা। ফিল্টাৰ লোড কৰা ফলাফলত প্ৰযোজ্য; পুৰণি শাৰীৰ বাবে অধিক লোড কৰক।',
  auditLoaded: 'লোড কৰা',
  auditMoreAvailable: 'অধিক উপলব্ধ',
  auditEndOfList: 'তালিকাৰ সমাপ্তি',
  auditFilterActive: 'ফিল্টাৰ সক্ৰিয়',
  auditFiltersActive: 'ফিল্টাৰ সক্ৰিয়',
  auditSeverityBreakdown: 'গুৰুত্ব বিভাজন (বৰ্তমান তালিকা)',
  auditPressSlash: 'কাৰ্য্য ফিল্টাৰত ফোকাছ কৰিবলৈ / টিপক',
  auditFilters: 'ফিল্টাৰ',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'সকলো ভূমিকা',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'মেটাডাটা JSON সন্ধান',
  auditFilterFromPlaceholder: 'আৰম্ভণি তাৰিখ আৰু সময়',
  auditFilterToPlaceholder: 'শেষ তাৰিখ আৰু সময়',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'সময় ক্ষেত্ৰ:',
  auditTimezoneSuffix: '(স্থানীয়)',
  auditHideCsvOptions: 'CSV স্তম্ভ বিকল্প লুকুৱাওক',
  auditShowCsvOptions: 'CSV স্তম্ভ বিকল্প দেখুৱাওক',
  auditCsvColCreatedAt: 'সৃষ্টি সময়',
  auditCsvColAction: 'কাৰ্য্য',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'মেটাডাটা',
  auditFooterLoaded: 'লোড কৰা',
  auditFooterLogs: 'অডিট লগ',
  auditFooterMoreAvailable: '(অধিক উপলব্ধ)',
  auditFooterAllLoaded: '(সকলো লোড কৰা)',
  auditActor: 'এক্টৰ',
  auditEntity: 'সত্তা',
  auditEventLog: 'ইভেন্ট লগ',
  notificationCenter: 'জাননী',
  notifChannelAll: 'সকলো',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ইমেইল',
  notifChannelPush: 'পুশ',
  notifChannelSms: 'SMS',
  notifStatusSent: 'পঠোৱা হ’ল',
  notifStatusFailed: 'ব্যৰ্থ',
  notifStatusPending: 'বাকী',
  notifEmpty: 'এতিয়ালৈকে কোনো জাননী নাই',
  notifLoadMore: 'আৰু ল’ড কৰক',
  adminNotifLog: 'জাননী লগ',
  adminNotifColUser: 'ব্যবহাৰকাৰী',
  adminNotifColRole: 'ভূমিকা',
  adminNotifNoData: 'এতিয়ালৈকে কোনো জাননী লগ হোৱা নাই',
  etaOwnerApproval: 'মালিকৰ অনুমোদনৰ বাবে অপেক্ষা',
  etaWorkInProgress: 'আনুমানিক সমাপ্তি',
  etaPaymentDeadline: 'পেমেণ্ট নিশ্চিতকৰণৰ সময়সীমা',
  etaWorkCompleted: 'কাম সম্পূৰ্ণ',
  etaDisputeReview: 'DE দলে বিবাদ পৰ্যালোচনা কৰিছে',
  etaMinutesRemaining: '{n} মিনিট বাকী',
  etaHoursRemaining: '{n} ঘণ্টা বাকী',
  txRecharge: 'ৱালেট ৰিচাৰ্জ',
  txBookingAdvance: 'বুকিং অগ্ৰিম',
  txBookingPayment: 'বুকিং পেমেণ্ট',
  txSettlement: 'ছেটেলমেণ্ট',
  txRefund: 'ৰিফাণ্ড',
  txPenalty: 'জৰিমনা',
  txCommission: 'কমিচন',
  tacTitle: "চৰ্তাৱলী",
  tacPrivacy: "গোপনীয়তা নীতি",
  tacRefund: "ৰিফান্ড নীতি",
  tacCancellation: "বাতিলকৰণ নীতি",
  tacServiceDelivery: "সেৱা প্ৰদান নীতি",
  tacIntro: "বুকিংৰ আগতে আমাৰ নীতি চাওক",
  tacBannerTitle: "চৰ্তাৱলী আপডেট উপলব্ধ",
  tacBannerOpen: "চৰ্তাৱলী খোলক",
  tacBannerAgree: "মই পঢ়িছোঁ আৰু সন্মত",
  tacBannerLater: "পিছত",
  clientPoliciesTitle: "ক্লায়েণ্ট নীতি",
  machineGroupAvailable: "উপলব্ধ",
  machineGroupBusy: "ব্যস্ত",
  dewateringReferral: "ডিৱাটাৰিং (পাম্প) সেৱা লাগেনে? MachineOS সোনকালে পাম্প ঠিকাদাৰ সেৱা যোগ কৰিব। ৰেফাৰেলৰ বাবে সাপোৰ্টত যোগাযোগ কৰক।",
  noActiveWork: "এই মাহত কোনো সক্ৰিয় কাম নাই",
  accountTab: "একাউণ্ট",
  recentActivity: "শেহতীয়া কাৰ্যকলাপ",
  goodMorning: "শুভ পুৱা",
  goodAfternoon: "শুভ দুপৰীয়া",
  goodEvening: "শুভ সন্ধিয়া",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
